(() => {
  var i = {};
  Shopify.theme.jsTestimonials = {
    init: function(i) {
      const t = i.find("[data-testimonial-slider]");
      t.flickity({
        wrapAround: !0,
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        watchCSS: !0
      }), t.on("settle.flickity", (function() {
        t.flickity("resize")
      })), i.on("click", ".testimonial__nav--prev", (function() {
        t.flickity("previous")
      })), i.on("click", ".testimonial__nav--next", (function() {
        t.flickity("next")
      }))
    },
    blockSelect: function(i, t) {
      const n = i.find("[data-testimonial-slider]");
      const e = $("#shopify-section-" + t).data("testimonial-index");
      n.flickity("select", e)
    },
    unload: function(i) {
      const t = undefined;
      i.find(".flickity-enabled").flickity("destroy"), $(".testimonial__nav--prev").off(), $(".testimonial__nav--next").off()
    }
  }
})();
//# sourceMappingURL=/s/files/1/0550/8297/5395/t/5/assets/z__jsTestimonials.js.map?v=1626371989
